import * as React from "react";
import { useDispatch, useSelector } from "react-redux";
import { updateStateData } from "../../../../Store/actions";
import MultiSelect from "../../../../components/commonComponents/Selectors/MultiSelect";

export default function NielsenRegionsFilter({ redux_param_name, reduxKeywordToSaveValue, paramToSaveFilteredRegion }) {
    const userStateData = useSelector((state) => state.userSelections);
    const dispatchAction = useDispatch();
    const [changesMade, setChangesMade] = React.useState(false);
    const [dataLoaded, setDataLoaded] = React.useState(false);
    const [selectedNielsenRegionFromDropdown, setSelectedNielsenRegionFromDropdown] = React.useState([]);
    const [selectedNielsenRegionNameForEmbeddable, setSelectedNielsenRegionNameForEmbeddable] = React.useState([]);

    let regionOptions = typeof userStateData.nielsen_campaign_regions !== "undefined" && userStateData.nielsen_campaign_regions.length !== 0 ? userStateData.nielsen_campaign_regions : [];

    let regionNames = typeof userStateData.nielsen_campaign_regions !== "undefined" && userStateData.nielsen_campaign_regions.length !== 0 ? [
        ...userStateData.nielsen_campaign_regions.map((regionInfo) => {
            return regionInfo.value;
        }),
    ] : [];

    // const filterRegionBasedOnNielsenCode = (nielsenRegionsSelected) => {
    //     return typeof userStateData.campaign_regions !== "undefined" && userStateData.campaign_regions.length !== 0 ?
    //         userStateData.campaign_regions.filter(region => {
    //             return nielsenRegionsSelected.includes(region.nielsen_code)
    //         }).map(region => region.label)
    //         :
    //         []
    // }

    React.useEffect(() => {
        setSelectedNielsenRegionNameForEmbeddable(regionNames);

        // selected values for regions
        const selectedValues = typeof userStateData[reduxKeywordToSaveValue] !== "undefined" && typeof userStateData[reduxKeywordToSaveValue][redux_param_name] !== "undefined" ? userStateData[reduxKeywordToSaveValue][redux_param_name] : regionNames

        if (selectedValues.length !== 0) {
            setSelectedNielsenRegionFromDropdown(
                regionOptions.filter((regionInfo) => {
                    return selectedValues.includes(regionInfo.value);
                })
            );
        }

        setTimeout(() => {
            setDataLoaded(true);
        }, 1000);
    }, []);

    return dataLoaded ? (
        <MultiSelect
            enableFullWidth={true}
            label={"Nielsen Region"}
            options={regionOptions}
            defaultVal={selectedNielsenRegionFromDropdown}
            selectionCheck={(option, value) => option.label === value.label}
            usedFor="regionsFilter"
            onChangeCall={(selectedOption) => {
                let userChoices = [];
                selectedOption.forEach((chosen) => {
                    if (chosen.label !== "(All)") {
                        userChoices.push(chosen.value);
                    } else {
                        userChoices.push([...new Set(regionNames)]);
                    }
                });
                setSelectedNielsenRegionNameForEmbeddable(userChoices);
                setSelectedNielsenRegionFromDropdown(selectedOption);
                setChangesMade(true);
            }}
            onBlurCall={(e) => {
                if (selectedNielsenRegionNameForEmbeddable.length !== 0 && changesMade === true) {
                    let regionSelections = selectedNielsenRegionNameForEmbeddable;
                    // to save filtered regions as pre-selected
                    // const filteredRegionsFromNielsenCode = filterRegionBasedOnNielsenCode(regionSelections)
                    dispatchAction(
                        updateStateData({
                            [reduxKeywordToSaveValue]: {
                                ...userStateData[reduxKeywordToSaveValue],
                                [redux_param_name]: regionSelections,
                                // [paramToSaveFilteredRegion]: filteredRegionsFromNielsenCode
                            },
                        })
                    );
                    setChangesMade(false);
                }
            }}
        />
    ) : (
        <></>
    );
}
